























































































import { Component } from 'vue-property-decorator';
import {Getter} from "vuex-class";
import AccountsFilter from "@/components/Accounts/AccountsFilter.vue";
import {ScrollButton} from "@/components";
import {AccountItem} from "@/store/accounts/types";
import BaseItemsPage from '../BaseItemsPage';

@Component({components: {AccountsFilter,ScrollButton}})
export default class Accounts extends BaseItemsPage<AccountItem> {
  @Getter("accounts") accountsResponse: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'login',
    'protocol',
    'transport',
    'status',
  ];

  getData(): any {
    return this.accountsResponse ? this.accountsResponse : [];
  }

  getJoinedArray(item: string[] | undefined | null): string | undefined | null {
    return item?.join(', ');
  }
}
